import Routes from 'ContentUtils/Routes';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const LEARN_MORE_HREF = 'https://knowledge.hubspot.com/forms/create-forms-using-the-new-forms-editor';
const i18nKey = key => `ContentComponents.cmv2.fields.form.simplifiedFormSelect.editInEditorMessage.${key}`;
const EditInEditorMessage = ({
  formId
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('message_jsx'),
      elements: {
        UIHelpIcon,
        UILink
      },
      options: {
        formEditorHref: Routes.formsEditor2({
          formId
        }),
        learnMoreLink: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: i18nKey('learnMoreLink_jsx'),
          elements: {
            UILink
          },
          options: {
            href: LEARN_MORE_HREF
          }
        })
      }
    })
  });
};
export default EditInEditorMessage;